export default __webpack_public_path__ + "static/media/on.496c529d.svg";